import{z as e}from"zod";function t(t){let n=t.map(t=>e.literal(t));return e.union(n)}export{t as constructZodLiteralUnionType};
//# sourceMappingURL=constructZodLiteralUnionType.js.map